var map = {
	"./ico-arrow.svg": "RmhP",
	"./ico-email.svg": "1Q4w",
	"./ico-fb.svg": "wguE",
	"./ico-forest.svg": "Qhl/",
	"./ico-ocean.svg": "EfDD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "K8wS";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/ico\-.*\.svg$
// module id = K8wS
// module chunks = 1